import React from 'react';
import { motion } from 'framer-motion';

/**
 * Single chat message bubble.
 * Supports three roles: user, assistant, manager, system (centered notice).
 */
export const ChatMessage = ({ message }) => {
  const { role, content } = message;

  if (role === 'system') {
    return (
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.15 }}
        className="flex justify-start w-full"
      >
        <div className="w-full text-center">
          <span className="inline-block text-xs text-muted-foreground bg-muted px-3 py-1.5 rounded-full">
            {content}
          </span>
        </div>
      </motion.div>
    );
  }

  const alignClass = role === 'user' ? 'justify-end' : 'justify-start';
  const bubbleClass =
    role === 'user'
      ? 'bg-foreground text-background rounded-tl-xl rounded-tr-sm rounded-bl-xl rounded-br-xl'
      : role === 'manager'
      ? 'bg-secondary border border-foreground/20 rounded-tl-sm rounded-tr-xl rounded-bl-xl rounded-br-xl'
      : 'bg-muted rounded-tl-sm rounded-tr-xl rounded-bl-xl rounded-br-xl';

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.15 }}
      className={`flex ${alignClass}`}
      data-testid={`chat-msg-${role}`}
    >
      <div className="max-w-[85%]">
        {role === 'manager' && (
          <span className="text-[10px] text-muted-foreground ml-1 block mb-0.5">Manager</span>
        )}
        {/* Вот здесь добавлены классы break-words, break-all и whitespace-pre-wrap */}
        <div className={`px-4 py-2.5 text-sm leading-relaxed break-words break-all whitespace-pre-wrap ${bubbleClass}`}>
          {content}
        </div>
      </div>
    </motion.div>
  );
};

export const TypingIndicator = () => (
  <div className="flex justify-start" data-testid="chat-typing">
    <div className="bg-muted px-4 py-3 rounded-xl flex gap-1.5">
      <span className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
      <span className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
      <span className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
    </div>
  </div>
);

export default ChatMessage;
